import { render } from "./StationedUnit.vue?vue&type=template&id=49ec2ab0"
import script from "./StationedUnit.vue?vue&type=script&lang=js"
export * from "./StationedUnit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tooltips/troops/StationedUnit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49ec2ab0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49ec2ab0', __exports__)) {
    api.reload('49ec2ab0', __exports__)
  }
  
  module.hot.accept("./StationedUnit.vue?vue&type=template&id=49ec2ab0", () => {
    api.rerender('49ec2ab0', render)
  })

}


export default __exports__